import { render, staticRenderFns } from "./FileDownloadPost.vue?vue&type=template&id=e5428944&scoped=true"
import script from "./FileDownloadPost.vue?vue&type=script&lang=js"
export * from "./FileDownloadPost.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadPost.vue?vue&type=style&index=0&id=e5428944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5428944",
  null
  
)

export default component.exports